import { MessagePart } from '../types';
import { hasVehicleProperties } from '../vehicleDetection';
import { parseReplyMessage } from '../replyMessageParser';
import { logger } from '../../logger';

export const parseMarkdownJSON = async (content: string): Promise<MessagePart[]> => {
  const jsonBlockMatch = content.match(/```json\s*\n?([\s\S]*?)\n?\s*```/);
  if (!jsonBlockMatch) {
    return [];
  }

  try {
    const extractedJson = jsonBlockMatch[1].trim();
    logger.log('*** EXTRACTED JSON FROM MARKDOWN:', extractedJson.substring(0, 200) + '...');
    const parsedExtracted = JSON.parse(extractedJson);
    
    return await parseExtractedJSON(parsedExtracted);
  } catch (extractError) {
    logger.log('*** Failed to parse extracted JSON:', extractError);
    return [];
  }
};

const parseExtractedJSON = async (parsedExtracted: any): Promise<MessagePart[]> => {
  const parts: MessagePart[] = [];
  
  // CHECK FOR REPLY_OPTIONS AT ROOT LEVEL (both cases - array and object)
  if (parsedExtracted.reply_options && Array.isArray(parsedExtracted.reply_options)) {
    parts.push({ type: 'reply_options', content: { reply_options: parsedExtracted.reply_options } });
  }
  
  if (parsedExtracted.Reply_Options || parsedExtracted.Content?.Reply_Options) {
    // If there's also a Reply_Message, process that first and add Reply_Options to it
    if (parsedExtracted.Reply_Message) {
      logger.log('*** FOUND both Reply_Message and root-level Reply_Options in extracted JSON - processing both');
      const replyParts = await parseReplyMessage(parsedExtracted);
      parts.push(...replyParts);
    } else {
      // Handle both array format and object format - check both locations
      const replyOptions = parsedExtracted.Reply_Options || parsedExtracted.Content?.Reply_Options;
      const replyOptionsContent = { Reply_Options: replyOptions };
      parts.push({ type: 'reply_options', content: replyOptionsContent });
    }
  } else if (parsedExtracted.Reply_Message) {
    logger.log('*** FOUND Reply_Message in extracted JSON, calling parseReplyMessage');
    const replyParts = await parseReplyMessage(parsedExtracted);
    parts.push(...replyParts);
  } else if (hasVehicleProperties(parsedExtracted)) {
    parts.push({ type: 'vehicle', content: parsedExtracted });
  }
  
  return parts;
};